import { useState } from 'react';

import { styled } from 'styled-components';
import { LuLineChart } from 'react-icons/lu';
import { TbMathXMinusY } from 'react-icons/tb';
import { VscSymbolOperator } from 'react-icons/vsc';
import { IoLayersOutline } from 'react-icons/io5';

import { LayerBlocks } from 'types';
import BlockGroup from './components/BlockGroup';
import { LAYER_MENU_PADDING } from 'constants/style';

const Container = styled.div`
  padding: ${`${LAYER_MENU_PADDING}px 0`};
`;

interface LayerMenuProps {
  keyword: string;
  blocks: LayerBlocks;
}

const LayerMenu = ({ keyword, blocks }: LayerMenuProps) => {
  const [selectedGroup, setSelectedGroup] = useState('Layer');

  const onGroupClick = (newSelectedGroup: string) => {
    setSelectedGroup((prevGroup) => (prevGroup === newSelectedGroup ? '' : newSelectedGroup));
  };

  return (
    <Container>
      <BlockGroup
        keyword={keyword}
        isSelected={selectedGroup === 'Layer'}
        title="Layer"
        Icon={IoLayersOutline}
        blocks={blocks['layer']}
        onGroupClick={() => onGroupClick('Layer')}
      />
      <BlockGroup
        keyword={keyword}
        isSelected={selectedGroup === 'Activation'}
        title="Activation"
        Icon={LuLineChart}
        blocks={blocks['activation']}
        onGroupClick={() => onGroupClick('Activation')}
      />
      <BlockGroup
        keyword={keyword}
        isSelected={selectedGroup === 'Loss'}
        title="Loss"
        Icon={TbMathXMinusY}
        blocks={blocks['loss']}
        onGroupClick={() => onGroupClick('Loss')}
      />
      <BlockGroup
        keyword={keyword}
        isSelected={selectedGroup === 'Operation'}
        title="Operation"
        Icon={VscSymbolOperator}
        blocks={blocks['operation']}
        onGroupClick={() => onGroupClick('Operation')}
      />
      <BlockGroup
        keyword={keyword}
        isSelected={selectedGroup === 'Optimizer'}
        title="Optimizer"
        Icon={LuLineChart}
        blocks={blocks['optimizer']}
        onGroupClick={() => onGroupClick('Optimizer')}
      />
    </Container>
  );
};

export default LayerMenu;
